import { render, staticRenderFns } from "./WorkerReportsDashboard.vue?vue&type=template&id=1a2592b8&"
import script from "./WorkerReportsDashboard.vue?vue&type=script&lang=js&"
export * from "./WorkerReportsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports